// UI language with translate.js (like tutory/webapp): t(key, count/subkey, {placeholders})
import m from './m.js'
import translate from 'translate.js'
import de from './translations/de.js'
import en from './translations/en.js'

export const LANGUAGES = { en: 'English', de: 'Deutsch' }
const MESSAGES = { en, de }

function initial() {
  try {
    const saved = localStorage.getItem('lang')
    if (saved in MESSAGES) return saved
  } catch {
    // storage unavailable (private mode, blocked): works without it
  }
  return navigator.language?.toLowerCase().startsWith('de') ? 'de' : 'en'
}

export let language = initial()
let current = translate(MESSAGES[language])

/** Translates a key; see translate.js for counts, subkeys and placeholders. */
export function t(...args) {
  return current(...args)
}
// m.t(...) like in tutory/webapp
m.t = t

export function setLanguage(lang) {
  if (!(lang in MESSAGES)) return
  language = lang
  current = translate(MESSAGES[lang])
  document.documentElement.lang = lang
  try {
    localStorage.setItem('lang', lang)
  } catch {
    // storage unavailable (private mode, blocked): works without it
  }
  m.redraw()
}

document.documentElement.lang = language

const UNITS = [
  ['year', 31_536_000],
  ['month', 2_592_000],
  ['day', 86_400],
  ['hour', 3600],
  ['minute', 60],
]

/** "3 minutes ago" / "vor 3 Minuten" in the current language. */
export function timeAgo(iso) {
  const seconds = (Date.now() - new Date(iso)) / 1000
  if (seconds < 60) return t('time.justNow')
  const [unit, size] = UNITS.find(([, s]) => seconds >= s)
  return new Intl.RelativeTimeFormat(language, { numeric: 'always' }).format(
    -Math.floor(seconds / size),
    unit
  )
}
